import React from 'react';

function NRReportsIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 13C15 12.4477 15.4477 12 16 12C16.5523 12 17 12.4477 17 13V16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V13Z"
        fill={color}
      />
      <path d="M7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16V8Z" fill={color} />
      <path
        d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14Z"
        fill={color}
      />
      <path
        d="M11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V10Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5344 3.64855C15.1556 3.23529 14.6207 3 14.0601 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10.389C21 9.8886 20.8124 9.40639 20.4743 9.03753L15.5344 3.64855ZM5 5H14.0601L19 10.389V19H5V5Z"
        fill={color}
      />
    </svg>
  );
}

export default NRReportsIcon;
